import React, { memo, useEffect, useState } from "react";

import { classNames } from "helpers";
import { ShowcaseStage } from "ui/components/Showcase";

import DocumentsSlide from "./components/DocumentsSlide";
import FleetSlide from "./components/FleetSlide";
import ServiceSlide from "./components/ServiceSlide";
import { LOGIN_SHOWCASE_SLIDE_MS, LOGIN_SHOWCASE_SLIDES } from "./consts";
import { ShowcaseSlideId } from "./types";

const SLIDE_COMPONENTS: Record<ShowcaseSlideId, React.FC> = {
  fleet: FleetSlide,
  documents: DocumentsSlide,
  service: ServiceSlide,
};

/**
 * Izmjenjivi slajdovi lijevog panela prijave: svaki prikazuje isječke sučelja Orytrona kao
 * lebdeće kartice, a ispod su naslov, opis i točkice slajdova.
 */
const LoginShowcase: React.FC = () => {
  const [slideIndex, setSlideIndex] = useState<number>(0);

  useEffect(() => {
    const timer = setInterval(
      () => setSlideIndex((index) => (index + 1) % LOGIN_SHOWCASE_SLIDES.length),
      LOGIN_SHOWCASE_SLIDE_MS
    );

    return () => clearInterval(timer);
  }, []);

  const slide = LOGIN_SHOWCASE_SLIDES[slideIndex];
  const SlideContent = SLIDE_COMPONENTS[slide.id];

  return (
    <div className="flex flex-col flex-1 w-full select-none pointer-events-none" aria-hidden="true">
      <div className="flex flex-1 items-center justify-center">
        {/* `key`: novi slajd se iznova montira, pa kartice ponovno ulete. */}
        <ShowcaseStage key={slide.id}>
          <SlideContent />
        </ShowcaseStage>
      </div>

      <div className="px-8 pb-12 text-center">
        <div key={slide.id} className="motion-safe:animate-showcaseFadeIn">
          <div className="text-3xl font-bold leading-tight text-white">{slide.title}</div>
          <p className="mt-3 text-base text-blue-100">{slide.description}</p>
        </div>
        <div className="flex items-center justify-center gap-2 mt-6">
          {LOGIN_SHOWCASE_SLIDES.map((item, index) => (
            <span
              key={item.id}
              className={classNames(
                "h-1.5 rounded-full transition-all duration-300",
                index === slideIndex ? "w-6 bg-amber-400" : "w-1.5 bg-white/40"
              )}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default memo(LoginShowcase);
